import React from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames/bind';
import styles from './RegisterFormInput.module.scss';

export type InputType =
  | 'text'
  | 'number'
  | 'email'
  | 'password'
  | 'checkbox'
  | 'date';

type Props = {
  value: any;
  id?: string;
  type?: InputType;
  name: string;
  label?: string;
  placeholder?: string;
  explicationMessage?: string;
  tooltipMessage?: string;
  className?: string;
  tooltipId?: string;
  onChange: (newValue: any) => void;
  onBlur?: (e: any) => void;
  pattern?: string;
  max?: string;
  inputclassName?: string;
  min?: number;
  currencyClass?: string;
  showCurrency?: boolean;
  onClick?: any;
  maxLength?: any;
  onKeyPress?: (e: any) => void;
};

const RegisterFormInput = ({
  value,
  id,
  name,
  type = 'text',
  label,
  placeholder,
  explicationMessage,
  tooltipId,
  tooltipMessage,
  className,
  onChange,
  onBlur,
  pattern,
  max,
  min,
  inputclassName,
  currencyClass,
  showCurrency,
  onClick,
  maxLength,
  onKeyPress,
}: Props) => {
  return (
    <div className={'form-group ' + classNames(className)}>
      {label && (
        <label>
          {label}
          {tooltipMessage && (
            <span
              className={styles.infoicon}
              data-tip
              data-for={tooltipId ? tooltipId : 'explicationTooltip'}
            >
              <img
                src={process.env.PUBLIC_URL + '/images/icons/tooltip-icon.svg'}
              />
            </span>
          )}
        </label>
      )}
      {showCurrency ? (
        <>
          <div
            className={
              'Input Input-icon Input-icon--before ' +
              currencyClass +
              ' Input-textLeft'
            }
          >
            <input
              id={id}
              type={type}
              name={name}
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              onBlur={onBlur}
              className={'form-class ' + classNames(inputclassName)}
              pattern={pattern}
              max={max}
              min={min}
              onClick={onClick}
              maxLength={maxLength}
              onKeyPress={onKeyPress}
            />
          </div>
          <span></span>
        </>
      ) : (
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          className={'form-class ' + classNames(inputclassName)}
          pattern={pattern}
          max={max}
          min={min}
          onKeyPress={onKeyPress}
        />
      )}
      {tooltipMessage && explicationMessage && (
        <>
          <div
            className={styles.explication}
            data-tip
            data-for="explicationTooltip"
          >
            {explicationMessage}
          </div>
          <ReactTooltip
            id={tooltipId ? tooltipId : 'explicationTooltip'}
            place="bottom"
            effect="solid"
            multiline={true}
            className={styles.tooltip}
          >
            {tooltipMessage}
          </ReactTooltip>
        </>
      )}
    </div>
  );
};

export default RegisterFormInput;
